import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from '@angular/core';
import { AuthService } from 'app/auth/auth.service';
import { UserSession } from 'app/interfaces/user-session';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.sass'],
})
export class HeaderComponent implements OnInit {
  roleUserLogged: string | undefined;
  userLogged: string | undefined;
  total_brand: number = 0;
  total_r2w: number = 0;
  user: UserSession | null = null;

  showDropdownProfile: boolean = false;
  @ViewChild('dropdownProfile') dropdownProfile!: ElementRef;
  constructor(private auth: AuthService) {}

  ngOnInit(): void {
    const user = this.auth.getCurrentUser();
    this.userLogged = user?.nome + ' ' + user?.cognome;
    this.roleUserLogged = user?.tipo;
  }

  logout(): void {
    this.auth.logout();
  }
  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event): void {
    if (
      this.showDropdownProfile &&
    (
        !this.dropdownProfile.nativeElement.contains(event.target))
    ) {
      this.showDropdownProfile = false;
    }
  }
}
